import { render, staticRenderFns } from "./EditRmaModal.vue?vue&type=template&id=401cc46c"
import script from "./EditRmaModal.vue?vue&type=script&lang=js"
export * from "./EditRmaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports